import { NgModule } from '@angular/core'
import { MatButtonModule } from "@angular/material/button"
import { MatDialogModule } from "@angular/material/dialog"
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner"
import { TrDeleteModalComponent } from "./delete-modal/delete-modal.component"
import { TrLoadingModalComponent } from "./loading-modal/loading-modal.component"

const COMPONENTS = [
  TrLoadingModalComponent,
  TrDeleteModalComponent,
]

@NgModule({
  imports: [
    MatDialogModule,
    MatProgressSpinnerModule,
    MatButtonModule,
  ],
  exports: COMPONENTS,
  declarations: COMPONENTS,
  entryComponents: COMPONENTS,
})
export class TrModalsModule { }
